import { createPlannedGarmentPattern } from '@/lib/patterns/placeholder';
import { OVERCOAT_DISPLAY_OPTIONS } from '@/lib/patterns/overcoat/displayOptions';

export const OVERCOAT_DEFAULT_MEASUREMENTS = {
  chest: 42,
  waist: 38,
  seat: 44,
  shoulder: 18.5,
  sleeve_length: 25,
  coat_length: 42,
};

export { OVERCOAT_DISPLAY_OPTIONS };

export function generateOvercoatPattern() {
  return createPlannedGarmentPattern(
    'overcoat',
    'Overcoat draft is planned after Jacket in the rollout sequence.',
  );
}
